import { actions } from "./actions";
import { getConfig } from "./init";

(async function () {

  const body = document.querySelector("body");
  const script = document.querySelector('script[data-quiz-id]');
  if(!script)
  return;
  const quizId = script.dataset.quizId;
  try {

    const quizConfig = await getConfig(quizId, true);
    actions["body"].init(body, quizConfig, true);
  } catch (error) {
    console.error(error);
  }
})();
